(function() {

  em.gridModal = {};

  var btnEl = document.querySelector(".js-grid-modal-btn");
  var areas = document.querySelectorAll("map area");

  em.gridModal.init = function() {
    if (btnEl !== null) {
     em.gridModal.setupBtnEvents();
    }
  };

  em.gridModal.setupBtnEvents = function() {
    btnEl.addEventListener('click', function(e) {
      if (!document.body.classList.contains('has-open-grid-modal')) {
        e.preventDefault();
        document.body.classList.add('has-open-grid-modal');
      } else {
        document.body.classList.remove('has-open-grid-modal');
      }
    });

    areas.forEach(function(area){
      area.addEventListener('click', function(e) {
        if (!document.body.classList.contains('has-open-grid-modal')) {
          e.preventDefault();
          document.body.classList.add('has-open-grid-modal');
        } else {
          document.body.classList.remove('has-open-grid-modal');
        }
      });
    });
  };

})();